import styled from 'styled-components/macro';

export const Wrapper = styled('div')`
  * {
    text-align: left;
    .bold {
      font-weight: 600 !important;
    }
    h3,
    h4 {
      margin-top: 0 !important;
    }
  }
  .content-wrapper-product {
    min-width: 400px;
    @media (max-width: 700px) {
      margin-top: 20px !important;
    }
    @media (max-width: 500px) {
      min-width: 100%;
    }
  }
`;
